import { useGetGlobalSettingsQuery } from '@onesource/services';
import { ContactSection } from '@onesource/components';
import bannerBg from './banner-bg.webp';

export const ContactUsPage = () => {
  const { data: response, isLoading } = useGetGlobalSettingsQuery();
  const formUrl = response?.CONTACT_FORM_IFRAME_URL?.iframeUrl?.trim();

  return <ContactSection formUrl={formUrl} bannerBg={bannerBg} isLoading={isLoading} />;
};
